<script lang="ts">
  import { VegaLite, type View, type VisualizationSpec } from "svelte-vega";
  import type { LegendLayout } from "vega";
  import { expressionInterpreter } from "vega-interpreter";

  interface Props {
    data: Record<string, unknown>;
    spec: VisualizationSpec;
    viewVL: View | undefined;
    isMobile: boolean;
    bottomLegend?: boolean;
  }

  let {
    data,
    spec,
    viewVL = $bindable(),
    isMobile,
    bottomLegend,
  }: Props = $props();

  const lightColor = "#144236";
</script>

<div class="vega-container">
  <VegaLite
    {data}
    {spec}
    bind:view={viewVL}
    options={{
      actions: false,
      expr: expressionInterpreter,
      ast: true,
      tooltip: { theme: "light" },
      config: {
        background: "transparent",
        view: {
          stroke: "transparent",
        },

        title: {
          color: lightColor,
          subtitleColor: lightColor,
        },

        style: {
          "guide-label": {
            fill: lightColor,
          },
          "guide-title": {
            fill: lightColor,
          },
        },

        axis: {
          domainColor: "lightgrey",
          gridColor: "#33113610",
          tickColor: "lightgrey", //lightColor,
          labelColor: "#144236",
          labelFontSize: 10,
          titleFontWeight: "normal",
          titleFontSize: 18,
          titlePadding: 16,
          titleColor: "#144236",
          titleLineHeight: 28,
        },

        legend: {
          labelLimit: 300,
          titleFontWeight: "normal",
          titleFontSize: 14,
          titleColor: "#144236",
          labelFontSize: 14,
          labelColor: "#144236",
          rowPadding: 6,
          titlePadding: 6,
          orient: isMobile || bottomLegend ? "bottom" : "right",
          direction: isMobile || bottomLegend ? "horizontal" : "vertical",
          ...(isMobile || bottomLegend
            ? {
                layout: {
                  bottom: {
                    anchor: "middle",
                  },
                } as LegendLayout as any,
              }
            : {}),
          ...(isMobile && { symbolLimit: 8 }),
        },
      },
    }}
  />
</div>

<style lang="postcss">
  .vega-container :global(text) {
    font-family: inherit !important;
    color: inherit !important;
  }

  :global(.vg-tooltip) {
    /* border: 1px solid #333 !important; */
    font-family: serif !important;
    font-size: 14px !important;
    color: #144236 !important;
  }

  :global(.vg-tooltip table) {
    border-spacing: 26px 0 !important;
  }

  :global(.vg-tooltip .key) {
    @apply !text-almanac-dark-green/60 !pr-1;
  }

  :global(.vg-tooltip td) {
    @apply !align-top;
  }

  :global([aria-label*="Y-axis"] .role-axis-title > text > tspan:last-child) {
    @apply fill-almanac-dark-green/60 text-base;
  }

  :global([aria-label*="X-axis"] .role-axis-title > text > tspan:last-child) {
    @apply fill-almanac-dark-green/60 text-base;
  }
</style>
